import { render, staticRenderFns } from "./abnormal.vue?vue&type=template&id=dd52b21a&scoped=true&"
import script from "./abnormal.vue?vue&type=script&lang=js&"
export * from "./abnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd52b21a",
  null
  
)

export default component.exports